import { render, staticRenderFns } from "./BuilderScreenV2.vue?vue&type=template&id=55f92f72&scoped=true"
import script from "./BuilderScreenV2.vue?vue&type=script&lang=js"
export * from "./BuilderScreenV2.vue?vue&type=script&lang=js"
import style0 from "./BuilderScreenV2.vue?vue&type=style&index=0&id=55f92f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f92f72",
  null
  
)

export default component.exports